export default "/_nuxt/19b268253037c13ca3e8bc91491033c6.svg";